import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Loader from '../../../components/base/Loader/Loader';
import { Icons } from '../../../components/base/BootstrapComponents';
import {
  Dialog, DialogClose, DialogContent, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { hideHistoryPopup, loadHistoryList, hostCommandCancel } from '../actions';
import { getPaginationOpts, responseLogWithNotification, useFilterData } from '../../../utils/utils';
import { getParkingMetersData } from '../reducer';
import Grid from '../../../components/base/Grid/Grid';
import { dateTimeFormatter } from '../../../utils/formatters';
import Pagination from '../../../components/base/Pagination/Pagination';
import notificationDecorator from '../../Notifications/notificationDecorator';
import { HOST_COMMAND_STATUS } from '../constants';
import { showGlobalConfirm } from '../../System/actions';
import { OperationStatusFormatter } from './ParkingFormatters';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';

export default function ParkingMeterHistoryPopup() {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    currentParkingMeter = null,
    loadingHostCommandHistory,
    hostCommandHistory,
    loadingHostCommandCancel,
    hostCommandHistoryMeta,
  } = useSelector(getParkingMetersData);

  const momentRangeObject = getDefaultDataRange(7, 'day');
  const handleClose = () => {
    dispatch(hideHistoryPopup());
  };
  const handleLoadingHostList = opts => {
    if (!currentParkingMeter || !currentParkingMeter.id) {
      return null;
    }
    let filterData = { ...filter };
    if (opts && opts.filterData) {
      filterData = { ...opts.filterData };
      opts.page = 1;
    }
    const paginationOpts = getPaginationOpts(hostCommandHistoryMeta, opts);
    dispatch(loadHistoryList({
      host_id: currentParkingMeter.id,
      ...paginationOpts,
      filter: {
        created_at_from: filterData.date[0].format('YYYY-MM-DD'),
        created_at_to: filterData.date[1].format('YYYY-MM-DD'),
      },
    })).catch(responseLogWithNotification);
  };
  const {
    handleChangeFilter, filter, getFilterValue, clearFilter,
  } = useFilterData({ date: momentRangeObject }, handleLoadingHostList, 'status-history-filter1');

  useEffect(() => { handleLoadingHostList({ page: 1 }); }, []);
  if (!currentParkingMeter || !currentParkingMeter.id) {
    return null;
  }

  const handleHostCommandCancel = id => {
    if (!id) {
      return null;
    }
    dispatch(showGlobalConfirm({
      confirmTitle: 'Отмена операции',
      confirmMessage: 'Вы уверены что хотите отменить операцию?',
    })).then(() => {
      dispatch(hostCommandCancel(id)).then(() => {
        notificationDecorator({
          title: 'Отмена операции',
          message: formatMessage({ id: 'success' }),
        });
      })
        .then(() => {
          handleLoadingHostList();
        })
        .catch(response => {
          responseLogWithNotification(response, 'Отмена операции');
        });
    });
  };

  const rowClassFormatter = item => {
    if (item.status === HOST_COMMAND_STATUS.CANCELED) {
      return 'canceled';
    }
    return '';
  };

  const columns = [
    {
      dataField: 'command_template',
      text: 'Название команды',
      formatter: a => a.name,
      disableSort: true,
    },
    {
      dataField: 'created_at',
      text: 'Время создания команды',
      formatter: dateTimeFormatter,
      disableSort: true,
    },
    {
      dataField: 'expiration_at',
      text: 'Выполнить не позже',
      formatter: dateTimeFormatter,
      disableSort: true,
    },
    {
      dataField: 'status',
      text: 'Статус',
      formatter: a => (
        <OperationStatusFormatter status={a} />
      ),
      disableSort: true,
    },
    {
      dataField: 'executed_at',
      text: 'Статус получен от устройства',
      formatter: dateTimeFormatter,
      disableSort: true,
    },
    {
      dataField: 'status',
      text: 'Отменить',
      formatter: (a, item) => (HOST_COMMAND_STATUS.WAITING === a ? <Icons className="close-command" customIcon icon="close" onClick={() => { handleHostCommandCancel(item.id); }} /> : null),
      disableSort: true,
      dataClassName: 'text-center',
    },
  ];
  return (
    <Dialog
      onClose={handleClose}
      open
      className="parking-meter-history-popup"
      size="xl"
    >
      <DialogTitle
        header={`История команд паркомата ${currentParkingMeter.host}`}
        title={(
          <>
            <RangeDatePicker
              value={getFilterValue('date')}
              hideSmallButtons
              hidePickerIcon
              showArrowIcon
              usePortal
              handleChangeDate={date => { handleChangeFilter('date')({ target: { value: date } }); }}
              className="no-border margin-right"
            />
            <DialogClose onClick={handleClose} />
          </>
    )}
      />

      <DialogContent>
        <Loader global loading={loadingHostCommandHistory || loadingHostCommandCancel} />
        <div className="pmhp-tables-wrapper">
          <div className="sticky-table-wrapper custom-scroll-theme">
            <Grid
              loading={loadingHostCommandHistory}
              className="parking-meter-history-grid"
              columns={columns}
              data={hostCommandHistory}
              rowClassFormatter={rowClassFormatter}
            />
          </div>
        </div>
        <Pagination meta={hostCommandHistoryMeta} list={hostCommandHistory} handleChangeMeta={handleLoadingHostList} />
      </DialogContent>
    </Dialog>
  );
}
